<template>
    <div class="form">
        <ValidationObserver ref="form">

            <AddressForm

                :user="app_user"
                @data-changed="updateForm"
            >
            </AddressForm>

            <div class="row">
                <div class="col-12 text-right ">
                    <div class="wrap-border-top">
                        <div class="btns-wrap">
                            <a href="/application-step-1"
                               class="btn btn--outline-primary w-100 w-sm-auto">Back</a>
                            <a href="javascript:void(0)" @click="save" class="btn btn--secondary w-100 w-sm-auto">Continue</a>
                        </div>
                    </div>
                </div>
            </div>
        </ValidationObserver>
    </div>
</template>


<script>
import AddressForm from "../CommonForms/AddressForm.vue";
import ApplicationFormService from "../services/ApplicationFormService";

export default {
    name: "ApplicantFormStep2",
    components: {AddressForm},
    props: {
        states: {
            type: Array,
            required: true
        },
        app_user: {
            type: Object,
        }
    },
    data() {
        return {
            dataFormStep2: {}
        }
    },
    methods: {
        save() {
            (async () => {
                const valid = await this.$refs.form.validate();

                if (!valid) {
                    this.$showValidationErrorMessage();
                    return;
                }
                try {
                    const response = await ApplicationFormService.saveStep2(this.dataFormStep2);
                    if (response.status === 200) {
                        this.$showSuccessMessage();
                        setTimeout(() => {
                            window.location.href = '/application-step-3';
                        }, 1000)
                    }
                } catch (error) {
                    this.$handleErrors(error)
                }
            })();
        },
        updateForm(dataAddressForm) {
            this.dataFormStep2 = dataAddressForm;
        }
    },
}

</script>

<style scoped>

</style>
